module.exports = __webpack_public_path__ + "static/media/Monitor-icon.cbb9f0e7.svg";